import kelownaAccount from './kelowna/account.svg'
import kelownaCheckMark from './kelowna/checkMark.svg'
import kelownaExclamationPoint from './kelowna/exclamationPoint.svg'
import kelownaLock from './kelowna/lock.svg'
import kelownaLogo from './kelowna/logo.png'

import citadelAccount from './citadel/account.svg'
import citadelCheckMark from './citadel/checkMark.svg'
import citadelExclamationPoint from './citadel/exclamationPoint.svg'
import citadelLock from './citadel/lock.svg'
import citadelLogo from './citadel/logo.svg'

import pittmeadowsAccount from './pittmeadows/account.svg'
import pittmeadowsCheckMark from './pittmeadows/checkMark.svg'
import pittmeadowsExclamationPoint from './pittmeadows/exclamationPoint.svg'
import pittmeadowsLock from './pittmeadows/lock.svg'
import pittmeadowsLogo from './pittmeadows/logo.png'
import pittmeadowsVerticalLogo from './pittmeadows/verticalLogo.png'

import princegeorgeAccount from './princegeorge/account.svg'
import princegeorgeCheckMark from './princegeorge/checkMark.svg'
import princegeorgeExclamationPoint from './princegeorge/exclamationPoint.svg'
import princegeorgeLock from './princegeorge/lock.svg'
import princegeorgeLogo from './princegeorge/logo.png'
import princegeorgeVerticalLogo from './princegeorge/verticalLogo.png'

import kamloopsAccount from './kamloops/account.svg'
import kamloopsCheckMark from './kamloops/checkMark.svg'
import kamloopsExclamationPoint from './kamloops/exclamationPoint.svg'
import kamloopsLock from './kamloops/lock.svg'
import kamloopsLogo from './kamloops/logo.png'

import saskatoonAccount from './saskatoon/account.svg'
import saskatoonCheckMark from './saskatoon/checkMark.svg'
import saskatoonExclamationPoint from './saskatoon/exclamationPoint.svg'
import saskatoonLock from './saskatoon/lock.svg'
import saskatoonLogo from './saskatoon/logo.png'
import saskatoonVerticalLogo from './saskatoon/verticalLogo.png'

import { getRuntimeEnv, getRuntimeTheme } from '../runtimeEnv'

const THEME = getRuntimeTheme()
const runtimeLogoUrl = getRuntimeEnv('CLIENT_LOGO_URL')

const accountMapping = {
  kelownapir: kelownaAccount,
  citadel: citadelAccount,
  citadelpir: citadelAccount,
  citadelfoi: citadelAccount,
  pittmeadowspir: pittmeadowsAccount,
  pittmeadowsfoi: pittmeadowsAccount,
  princegeorgefoi: princegeorgeAccount,
  kamloopsfoi: kamloopsAccount,
  saskatoonfoi: saskatoonAccount,
  saskatoonpir: saskatoonAccount
}

const checkMarkMapping = {
  kelownapir: kelownaCheckMark,
  citadel: citadelCheckMark,
  citadelpir: citadelCheckMark,
  citadelfoi: citadelCheckMark,
  pittmeadowspir: pittmeadowsCheckMark,
  pittmeadowsfoi: pittmeadowsCheckMark,
  princegeorgefoi: princegeorgeCheckMark,
  kamloopsfoi: kamloopsCheckMark,
  saskatoonfoi: saskatoonCheckMark,
  saskatoonpir: saskatoonCheckMark
}

const exclamationPointMapping = {
  kelownapir: kelownaExclamationPoint,
  citadel: citadelExclamationPoint,
  citadelpir: citadelExclamationPoint,
  citadelfoi: citadelExclamationPoint,
  pittmeadowspir: pittmeadowsExclamationPoint,
  pittmeadowsfoi: pittmeadowsExclamationPoint,
  princegeorgefoi: princegeorgeExclamationPoint,
  kamloopsfoi: kamloopsExclamationPoint,
  saskatoonfoi: saskatoonExclamationPoint,
  saskatoonpir: saskatoonExclamationPoint
}

const lockMapping = {
  kelownapir: kelownaLock,
  citadel: citadelLock,
  citadelpir: citadelLock,
  citadelfoi: citadelLock,
  pittmeadowspir: pittmeadowsLock,
  pittmeadowsfoi: pittmeadowsLock,
  princegeorgefoi: princegeorgeLock,
  kamloopsfoi: kamloopsLock,
  saskatoonfoi: saskatoonLock,
  saskatoonpir: saskatoonLock
}

const logoMapping = {
  kelownapir: kelownaLogo,
  citadel: citadelLogo,
  citadelpir: citadelLogo,
  citadelfoi: citadelLogo,
  pittmeadowspir: pittmeadowsLogo,
  pittmeadowsfoi: pittmeadowsLogo,
  princegeorgefoi: princegeorgeLogo,
  kamloopsfoi: kamloopsLogo,
  saskatoonfoi: saskatoonLogo,
  saskatoonpir: saskatoonLogo
}

const verticalLogoMapping = {
  kelownapir: kelownaLogo,
  citadel: citadelLogo,
  citadelpir: citadelLogo,
  citadelfoi: citadelLogo,
  pittmeadowspir: pittmeadowsVerticalLogo,
  pittmeadowsfoi: pittmeadowsVerticalLogo,
  princegeorgefoi: princegeorgeVerticalLogo,
  kamloopsfoi: kamloopsLogo,
  saskatoonfoi: saskatoonVerticalLogo,
  saskatoonpir: saskatoonVerticalLogo
}

export const account = accountMapping[THEME]
export const checkMark = checkMarkMapping[THEME]
export const exclamationPoint = exclamationPointMapping[THEME]
export const lock = lockMapping[THEME]
export const logo = runtimeLogoUrl || logoMapping[THEME]
export const verticalLogo = runtimeLogoUrl || verticalLogoMapping[THEME]
